import React,{ useEffect } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { GetUrl, CTicksToDateString } from '../Utility.js';


function TypeSelect()
{
    const state=useSelector((state)=>state);
    const dispatch = useDispatch();

    const navigate = useNavigate();

    useEffect(()=>{
    
    },[state.DisplayType])

    const DClick = () =>{
        dispatch({type:'ChangeDisplayType',DisplayType:'D'});
    }
    const EClick = () =>{
        dispatch({type:'ChangeDisplayType',DisplayType:'E'});
    }

    function SelectD() {
        if(state.DisplayType === 'D')
        {
            return <><span className="radio-solid"></span></>
        }
        else
        {
            return '';
        }
    }

    function SelectE() {
        if(state.DisplayType === 'E')
        {
            return <><span className="radio-solid-2"></span></>
        }
        else
        {
            return '';
        }
    }

    const BackClick = async (e) => 
        {
            e.preventDefault();
            try
            {
                if(state.Result.length === 0)
                {
                    return;
                }
                
                if(state.Request === 1)
                {
                    return;
                }

                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                  alert('유저 정보 만료(다시 로그인 해주세요)');  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                  return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl()+'Back/Back', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey }),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.result === 0)
                    {
                        dispatch({type:'UpdateRemainTime', RemainTime:data.remain_time});
                        dispatch({type:'BackResult'});
                        dispatch({type:'UpdateRecord',record:data.record_array,stage_count:data.stage_count});
                    }
                    else if(data.result === 3)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                      var startTime = CTicksToDateString(data.start_time);
                      var endTime = CTicksToDateString(data.end_time);
        
                      var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                      alert(message);  
                      navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 12)
                    {
                        alert('사용 시간을 모두 소진 했습니다. 시간권 사용 후 다시 이용해 주세요.');  
                    }
                } 
                else
                {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});
            }
            catch(error)
            {
                dispatch({type:'Response'});
                console.error(error);
            }
        };

    const ResetClick = async (e) => 
        {
            e.preventDefault();
            try
            {
                if(state.Result.length === 0)
                {
                    return;
                }

                if(state.Request === 1)
                {
                    return;
                }

                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                  alert('유저 정보 만료(다시 로그인 해주세요)');  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                  return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl() + 'Reset/Reset', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey }),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.result === 0)
                    {
                        dispatch({type:'UpdateRemainTime', RemainTime:data.remain_time});
                        dispatch({type:'ResetResult'});
                    }
                    else if(data.result === 3)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                      var startTime = CTicksToDateString(data.start_time);
                      var endTime = CTicksToDateString(data.end_time);
        
                      var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                      alert(message);  
                      navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 12)
                    {
                        alert('사용 시간을 모두 소진 했습니다. 시간권 사용 후 다시 이용해 주세요.');  
                    }
                } 
                else
                {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});
            }
            catch(error)
            {
                dispatch({type:'Response'});
                console.error(error);
            }
        };


    function GetStageCount()
    {
        if(state.cur_stage === 0)
        {
            return 'STAGE START';
        }

        return 'STAGE ' + state.cur_stage;
    }

    return (           
    <div className='type-select-box'>
        <div className="stage-count-box">
                <h2><p>{GetStageCount()}</p></h2>
        </div>
           <div className='button-right'>
                <div className="back-button" onClick={BackClick}>
                        <h2><p>뒤로가기</p></h2>
                </div>
                <div className="clear-button" onClick={ResetClick}>
                        <h2><p>재시작</p></h2>
                </div>
           </div>

    </div>
    );
}

export default TypeSelect